import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_marketing-builder_landing_page_signup_modal_open-click';
/**
 * open signup modal on Builder landing page
 */
export function trackRetailerMarketingBuilderLandingPageSignupModalOpenClick(customParameterToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: true,
        parameters: { customParameterToken },
    });
}
